import styled from "styled-components";

export const ListModule = styled.div`
  display: flex;
  flex-direction: column;
  width: 96%;
  height: 100%;
  background-color: #0f1923ff;
  border: 4.5px solid #081019ff;
  margin-top: 30px;
  color: white;
`;
